import { THEME_COLORS } from "./colors";

export const setThemeColorsFromURL = (platform = "tcs") => {
  const colors = THEME_COLORS[platform] || THEME_COLORS.default;

  Object.entries(colors).forEach(([key, value]) => {
    document.documentElement.style.setProperty(key, value);
  });

  return colors;
};
